const animateSlider = (slider, sliderObject, direction, from, to, additionalSliderObject = undefined) => {
  const prevStep = sliderObject.eq(from);
  const nextStep = sliderObject.eq(to);
  const excludedSteps = prevStep.add(nextStep);
  const remainingSteps = sliderObject.not(excludedSteps);

  if(additionalSliderObject){
    const additionPrevStep = additionalSliderObject.eq(from);
    const additionalNextStep = additionalSliderObject.eq(to);
    const additionalExcludedSteps = additionPrevStep.add(additionalNextStep);
    const additionalRemainingSteps = additionalSliderObject.not(additionalExcludedSteps);

    gsap.to(additionalExcludedSteps, {
      x: `${-100 * to}%`,
      duration: 1,
      ease: 'pageInEasing',
      stagger: {
        each: 0.1,
        from: direction == 1 ? 'start' : 'end',
      },
      onComplete: () => slider.attr('data-is-blocked', 'none'),
    });
    gsap.set(additionalRemainingSteps, {
      x: `${-100 * to}%`,
    });
  }
  
  gsap.to(excludedSteps, {
    x: `${-100 * to}%`,
    duration: 1,
    ease: 'pageInEasing',
    stagger: {
      each: 0.1,
      from: direction == 1 ? 'start' : 'end',
    },
    onComplete: () => slider.attr('data-is-blocked', 'none'),
  });
  gsap.set(remainingSteps, {
    x: `${-100 * to}%`,
  });
};

$(window).on('load', function () {
  const sliderParents = $('.ug-slider-parent');
  sliderParents.each(function () {
    const ugSlider = $(this).find('.ug-slider-item-parent');
    const ugSliderNav = $(this).find('.slider-nav-parent');
    const ugAdditionalSlider = $(this).closest('.ug-step-parent').find('.ug-additional-slider-parent');
    if (ugSliderNav.length != 0) {
      if(ugAdditionalSlider.length != 0){
        const ugAdditionalSliderItems = ugAdditionalSlider.find('.ug-slider-item-parent');
        addStepAnimation(ugSliderNav, ugSlider, animateSlider, ugAdditionalSliderItems);
      } else {
        addStepAnimation(ugSliderNav, ugSlider, animateSlider);
      }
      addSliderInAnimation(ugSliderNav, false).progress(1);
    }
  });
});
